<template>
  <div v-if="isAddressBookLocation(option)">
    <strong class="location-name">{{ option.name }}</strong>
    <NamedAddress v-if="option.address" :address="option.address" />
    <span v-if="option.code" class="location-code">{{ option.code }}</span>
  </div>
  <NamedAddress v-else-if="option.address" :address="option.address" />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { Location } from '@rygen/rygen-ui/model';

import NamedAddress from '@rygen/rygen-ui/components/address/NamedAddress.vue';

const props = defineProps({
  option: {
    type: Object as PropType<Location>,
    required: true,
  },
});
const { option } = toRefs(props);

// Address book locations have IDs, Trimble results don't
const isAddressBookLocation = (location: Location) => !!location.id;
</script>
